import React from 'react'
import PropTypes from 'prop-types'
import styles from './ViewYourPlan.module.scss'

const ViewYourPlan = (props)  => {
  const {
    onClick
  } = props

  return (
    <button
      onClick={onClick}
      className={styles.viewYourPlan}
      type="button"
      data-test-id="viewYourPlan">
          view your plan
    </button>
  )
}

ViewYourPlan.propTypes = {
  onClick: PropTypes.func,
}

ViewYourPlan.defaultProps = {
  onClick: () => {}
}

export default ViewYourPlan



// WEBPACK FOOTER //
// ./src/components/Client/GoalsAndInvestmentStrategy/ViewYourPlan/ViewYourPlan.jsx